import { Grid, InputAdornment } from '@mui/material'
import { FormField } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'

export default function FormHorista() {
    return [
        <Grid item sm={4} xs={6}>
            <FormField
                name="maximoHorasDiarias"
                label="Máximo de horas diárias"
                type="time"
                helperText="Deixe em branco para indeterminado"
                InputProps={{
                    endAdornment: [
                        <InputAdornment position="start">h</InputAdornment>,
                        <IconeAjuda>
                            Máximo de horas que o funcionário pode trabalhar por
                            dia antes de ser considerado hora extra.
                            <br />
                            <br />O trabalhador horista tem os mesmos limites
                            legais na jornada que os demais trabalhadores em
                            regime CLT: 8 horas diárias, porém, o empregador em
                            comum acordo com o empregado pode estabelecer
                            condições de trabalho diferentes.
                        </IconeAjuda>,
                    ],
                }}
            />
        </Grid>,
    ]
}
